export const GET_ALL_COUPON_REQUEST = "GET_ALL_COUPON_REQUEST";
export const GET_ALL_COUPON_FAILURE = "GET_ALL_COUPON_FAILURE";
export const GET_ALL_COUPON_SUCCESS = "GET_ALL_COUPON_SUCCESS";

export const CREATE_COUPON_REQUEST = "CREATE_COUPON_REQUEST";
export const CREATE_COUPON_FAILURE = "CREATE_COUPON_FAILURE";
export const CREATE_COUPON_SUCCESS = "CREATE_COUPON_SUCCESS";

export const UPDATE_COUPON_REQUEST = "UPDATE_COUPON_REQUEST";
export const UPDATE_COUPON_FAILURE = "UPDATE_COUPON_FAILURE";
export const UPDATE_COUPON_SUCCESS = "UPDATE_COUPON_SUCCESS";

export const DELETE_COUPON_REQUEST = "DELETE_COUPON_REQUEST";
export const DELETE_COUPON_FAILURE = "DELETE_COUPON_FAILURE";
export const DELETE_COUPON_SUCCESS = "DELETE_COUPON_SUCCESS";